module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-03@2x.dfa3eebb.jpg";